import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { fontDefault, fontDefaultAlt } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { FormattedText } from '@mirinae/lessons/components/lesson/elements/Text';
import { FormattedKoPhrase } from '@mirinae/lessons/components/lesson/elements/Phrase';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';

const SummaryWrapper = styled(Element)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const SummaryFrame = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${lessonsPalette.grey[5]};
    border-radius: 10px;
    margin-bottom: 20px;
    width: ${os.isOthers ? 'fit-content' : 'calc(100% - 10px)'};
    padding: 30px 0;
    ${os.isOthers ? `
        width: 710px;
        height: 205px;
    ` : `
    `}
`;

const Title = styled.div`
    position: absolute;
    top: -15px;
    background: ${lessonsPalette.light[2]};
    border-radius: 17px;
    text-align: center;
    // margin-top: -17px;
    padding: 7px 20px;
    width: fit-content;
    font-family: ${fontDefaultAlt};
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: ${lessonsPalette.grey[2]};
`;

const MeaningBox = styled.div`
    display: flex;

    ${os.isOthers ? `
        flex-direction: row;
        padding: 0px 30px;
    ` : `
        flex-direction: column;\
    `}
`;

const Boxes = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${!os.isOthers && `
        width: calc(100% - 40px);
    `}
`;

const BoxTitle = styled.div`
    font-family: ${fontDefault};
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    color: ${lessonsPalette.darken[1]};
    ${os.isOthers && `
        width: 130px;
        margin-right: 20px;
    `}
`;

const BoxText = styled.div`
    font-family: ${fontDefault};
    font-weight: 400;
    line-height: 20px;
    color: ${lessonsPalette.primary.black};
    ${os.isOthers ? `
        font-size: 16px;
    ` : `
        margin-top: 10px;
        font-size: 14px;
    `}
`;

const ConditionsBox = styled(MeaningBox)`
    ${os.isOthers ? `
        margin-top: 15px;
    ` : `
        margin-top: 32px;
        padding-top: 32px;
        border-top: 1px solid ${lessonsPalette.grey[5]};
    `}
`;

const ExamplesBox = styled(MeaningBox)`
    ${os.isOthers ? `
        margin-top: 15px;
    ` : `
        margin-top: 32px;
        padding-top: 32px;
        border-top: 1px solid ${lessonsPalette.grey[5]};
    `}
`;

const ExampleStack = styled.div`
    display: flex;
    flex-direction: column;
    div {
        margin-bottom: 5px;
    }
    ${os.isOthers ? `
        align-items: center;
    ` : `
        div {
            text-align: left;
        }
        div:first-child {
            margin-top: 10px;
        }
    `}
`;

const Example = styled(FormattedKoPhrase)`
`;

const ExampleKOStyle = { koFontWeight: 'medium', koreanFontSize: '18px' };

const PatternSummary = ({ element }) => {
    const player = useContext(PlayerContext);

    return (
        <SummaryWrapper element={element}>
            <SummaryFrame>
                <Title>{element.fieldsByName.title.value}</Title>
                <Boxes>
                    <MeaningBox player={player}>
                        <BoxTitle>Meaning</BoxTitle>
                        <BoxText>
                            <FormattedText text={element.fieldsByName.meaning.value} styles={element.fieldsByName.meaning.styles} links={element.fieldsByName.meaning.links} />
                        </BoxText>
                    </MeaningBox>
                    <ConditionsBox player={player}>
                        <BoxTitle>{element.fieldsByName.conditionsTitle.value}</BoxTitle>
                        <BoxText>
                            <FormattedText text={element.fieldsByName.conditions.value} styles={element.fieldsByName.conditions.styles} links={element.fieldsByName.conditions.links} />
                        </BoxText>
                    </ConditionsBox>
                    <ExamplesBox player={player}>
                        <BoxTitle>Examples</BoxTitle>
                        <ExampleStack>
                            { !element.fieldsByName.example1.hidden && (
                                <Example phrase={element.fieldsByName.example1} phraseStyle={ExampleKOStyle} />
                            )}
                            { !element.fieldsByName.example2.hidden && (
                                <Example phrase={element.fieldsByName.example2} phraseStyle={ExampleKOStyle} />
                            )}
                        </ExampleStack>
                    </ExamplesBox>
                </Boxes>
            </SummaryFrame>
        </SummaryWrapper>
    );
};

export default PatternSummary;
